import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import "../scss/index.scss";
import { Link } from "react-router-dom";
import { resetPassword } from "../store/actions";
import { Helmet } from "react-helmet";
import partnersLogo from "../images/ISPartnersLogo.png";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  const handleSubmit = (email) => {
    if (email) {
      dispatch(resetPassword(email));
      window.location.href = "/login";
    }
  };
  const isLoading = useSelector((state) => state.userReducer.loading);

  return (
    <>
      <Helmet>
        <title>Recover Password | Instaswap Partners</title>
      </Helmet>
      <div className="axStage">
        <div className="axBg" />
        <div className="axVeil" />

        <div className="axBrand">
          <img src={partnersLogo} alt="InstaSwap Partners" style={{ height: 34, width: "auto" }} />
          <span className="nTag">INSTITUTIONAL</span>
        </div>

        <div
          className="axWrap"
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <div className="axModal" style={{ animation: "fadeUp .4s both" }}>
            <h2>Recover password</h2>
            <p>
              Enter the email connected to your partner account and we'll send
              you recovery instructions.
            </p>
            <input
              className="input"
              type="text"
              name="name"
              placeholder="Your email here"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              style={{ marginBottom: 14 }}
            />
            <button
              type="button"
              className="btnPrimary block"
              onClick={() => handleSubmit(email)}
            >
              {isLoading ? (
                <FontAwesomeIcon icon={faSpinner} spin />
              ) : (
                <span>Submit</span>
              )}
            </button>
            <p style={{ marginTop: 18, marginBottom: 0, textAlign: "center" }}>
              If you remember your password{" "}
              <Link to="/login" style={{ color: "#3ad17e", fontWeight: 600 }}>
                Sign In
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
